<div class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid">
    <div class="row">
        <div class="col-12 text-center">
            <strong>Statement of Income and Tax during the Income Year ended on 30/6/{{assessmentYearStart}}</strong>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-5">
            Name of the Taxpayer: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            TIN:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
    <div class="row margin-amt">
        <div class="col-12 d-flex">
            <div style="width:10%">
            </div>
            <div class="pl-3 text-left" style="width:60%">
                <strong>Particulars of Income</strong>
            </div>
            <div class="pr-3 text-right" style="width:30%">
                <strong>Amount in Taka</strong>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12">
            <table class="table table-bordered amountAtRight">
                <tbody class="child-text-center">
                    <tr>
                        <td width="10%" class="text-center">1.</td>
                        <td width="60%">Income from Employment (annex Schedule 1)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFEMP_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">2.</td>
                        <td width="60%">Income from Rent (annex Schedule 2)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFR_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">3.</td>
                        <td width="60%">Income from Agriculture (annex Schedule 3)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFA_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">4.</td>
                        <td width="60%">Income from Business (annex Schedule 4)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFB_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">5.</td>
                        <td width="60%">Income from Capital Gain</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFCG_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">6.</td>
                        <td width="60%">Income from Financial Assets (Bank Interest, Dividend, Securities Profit etc)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFFA_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">7.</td>
                        <td width="60%">Income from Other Sources (Royalty, License Fees, Honorarium, Govt. Incentive etc.)</td>
                      <td width="30%">{{ ( (returnData?.taxPaymentData?.poti_IFOS_Amt)  + (returnData?.taxPaymentData?.poti_IFOS_67_15 || 0) ) | currencySeparatorBD }}
                      </td>
                    </tr>
                    <tr *ngIf="returnData?.taxPaymentData?.poti_Undisclosed_Amt && returnData?.taxPaymentData?.poti_Undisclosed_Amt > 0">
                        <td width="10%" class="text-center"></td>
                        <td width="60%">Voluntary Disclosure of Income (1st Schedule)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_Undisclosed_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">8.</td>
                        <td width="60%">Share of Income from Firm or AoP</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_SOIFFAOP_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">9.</td>
                        <td width="60%">Income of Minor or Spouse (if not Taxpayer)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFMSUS_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">10.</td>
                        <td width="60%">Taxable Income from Abroad</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_FI_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr *ngIf="isCsrDonation">
                        <td width="10%" class="text-center"></td>
                        <td width="60%">Donation under 6th Schedule Part-2</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_TOTAL_Allowable_CSR_Donation_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">11.</td>
                        <td width="60%">Total Income (Aggregate of Serial 1 to 10<span *ngIf="isCsrDonation"> less donation under 6th Schedule Part-2</span>)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_Total_Income_Amt | currencySeparatorBD }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- second table  -->
    <div class="row margin-amt mb-2">
        <div class="col-12 d-flex">
            <div style="width:10%">
            </div>
            <div class="pl-3 text-left" style="width:60%">
                <strong>Tax Computation</strong>
            </div>
            <div class="pr-3 text-right" style="width:30%">
                <strong>Amount in Taka</strong>
            </div>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-12">
            <table class="table table-bordered amountAtRight">
                <tbody class="child-text-center">
                    <tr>
                        <td width="10%" class="text-center">12.</td>
                        <td width="60%">Gross Tax on Taxable Income</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Gross_Tax_Before_Tax_Rebate_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">13.</td>
                        <td width="60%">Tax Rebate (annex Schedule 5) including 1st quarter Incentive</td>
                        <td width="30%">{{addIncentive(returnData?.taxPaymentData?.tc_Tax_Rebate_Amt) | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">14.</td>
                        <td width="60%">Net Tax after Rebate & Incentive (12 – 13)</td>
                        <td width="30%">{{reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt) | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">15.</td>
                        <td width="60%">Minimum Tax</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Min_Tax_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">16.</td>
                        <td width="60%">Tax Payable (Higher of 14 and 15)</td>
                        <td width="30%">
                            {{
                                (reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt) > returnData?.taxPaymentData?.tc_Min_Tax_Amt
                                ? reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt)
                                : returnData?.taxPaymentData?.tc_Min_Tax_Amt) | currencySeparatorBD
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">17.</td>
                        <td width="60%" style="padding:0px; border: none;">
                            <table class="table table-bordered" style="margin:0px">
                                <tr>
                                    <td width="70%">(a) Net Wealth Surcharge (if applicable)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Net_Wealth_Surcharge  | currencySeparatorBD}}</td>
                                </tr>
                                <tr>
                                    <td width="70%">(b) Tobacco Surcharge (if applicable)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Tobacco_Surcharge | currencySeparatorBD}}</td>
                                </tr>
                                <tr>
                                    <td width="70%">(c) Environmental Surcharge (if applicable)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Environmental_Surcharge | currencySeparatorBD}}</td>
                                </tr>
                            </table>
                        </td>
                        <td width="30%">
                            {{returnData?.taxPaymentData?.tc_Net_Wealth_Surcharge_Amt | currencySeparatorBD}}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">18.</td>
                        <td width="60%">Delay Interest, Penalty or any other amount Under Income Tax Act (if any)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Undisclosed_Penalty_Amt | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">19.</td>
                        <td width="60%">Total Amount Payable (16 + 17 + 18)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Total_Payable_Amt | currencySeparatorBD }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- third table -->
    <div style="page-break-inside: avoid">
        <div class="row margin-amt mb-2">
            <div class="col-12 d-flex">
                <div style="width:10%">
                </div>
                <div class="pl-3 text-left" style="width:60%">
                    <strong>Particulars of Tax Payment</strong>
                </div>
                <div class="pr-3 text-right" style="width:30%">
                    <strong>Amount in Taka</strong>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12">
                <table class="table table-bordered amountAtRight">
                    <!-- <thead>
                        <tr>
                            <th>Column 1</th>
                            <th>Column 2</th>
                            <th>Column 3</th>
                        </tr>
                    </thead> -->
                    <tbody class="child-text-center">
                        <tr>
                            <td width="10%" class="text-center">20.</td>
                            <td width="60%">Tax Deducted or Collected at Source (attach proof)</td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.totalTDS  | currencySeparatorBD}}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">21.</td>
                            <td width="60%">Advance Tax paid (attach proof)</td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.totalAIT | currencySeparatorBD }}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">22.</td>
                            <td width="60%">Adjustment of Tax Refund (mention assessment year(s) of refund)</td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.adjustedTaxAmount | currencySeparatorBD }}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">23.</td>
                            <td width="60%">Tax Paid with this Return (attach proof)</td>
                            <td width="30%">{{(returnData?.ledgerServiceInfo?.regularPayment + returnData?.ledgerServiceInfo?.regularTaxPaid) | currencySeparatorBD }}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">24.</td>
                            <td width="60%">Total Tax Paid and Adjusted (20 + 21 + 22 + 23)</td>
                            <td width="30%">
                                {{ returnData?.paymentDetails?.totalAmount | currencySeparatorBD }}
                            </td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">25.</td>
                            <td width="60%">Excess Payment (24 - 19)</td>
                            <td width="30%">{{returnData?.taxPaymentData?.tc_S_Refundable | currencySeparatorBD }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row mb-4">
                    <div class="col-12">
                        <table class="table table-bordered">
                            <tr>
                                <td width="10%" class="text-center">26.</td>
                                <td width="60%">Tax Exempted / Tax Free Income (attach proof)</td>
                                <td width="30%" class="text-right pr-3">{{returnData?.taxPaymentData?.poti_Tax_Exempted_Income_Amt | currencySeparatorBD }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- fourth table -->
        <div class="row">
            <div class="col-12">
                <div class="text-center"><strong>List of Documents Furnished with this Return</strong></div>
                <div class="text-center font-italic">(Online submission requires no attachment)</div>
                <div class="custom-box text-center mt-2">
                <textarea *ngIf="inputEnable" class="form-control" rows="3" style="max-height: 340px; overflow-y: auto;"></textarea>
                </div>
            </div>
        </div>
        <div class="text-center mt-5">
            <strong> <u style="color: black;"> Verification</u> </strong>
        </div>
        <div class="container container-condensed">
            <!-- <div class="row mt-4">
                <div class="col-6 pl-2">
                    I <strong>{{returnData?.profileData?.assesName}}</strong>
                </div>
                <div class="col-6 text-right pr-2">
                    father / husband: <strong>{{returnData?.profileData?.fathersName}}</strong>
                </div>
            </div> -->
            <div class="row my-4">
                <div class="col-12" style="line-height: 30px;">
                    I&ensp;<strong>{{returnData?.profileData?.assesName}}</strong>
                    &ensp;father&nbsp;/&nbsp;husband:&nbsp;<strong>{{returnData?.profileData?.fathersName}}</strong>
                    &ensp;<span style="white-space: nowrap;">TIN&ensp;&ensp;<input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/></span>
                    &ensp;solemnly declare that to the best of my knowledge and belief the information given in this return
                        and statements and documents annexed herewith is correct and complete.
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-6">
                    Place:<br>
                    Date: {{ returnData?.submissionInfo?.submissionDate | safeDate:'dd/MM/yyyy' }}

                </div>
                <div class="col-6 text-center">
                    {{returnData?.profileData?.assesName}} <br>
                    ..................................................... <br>
                    Signature <br>
                    (Name in Block Letters) <br>
                    <strong><i>System generated document, it requires no signature</i></strong>
                    <!-- ব্যক্তি না হইলে পদবি ও সিল মোহর <br>
                    <div class="font-weight-bold font-italic mt-1">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।</div> -->
                </div>
            </div>
        </div>
    </div>

</div>
